import * as pc from 'playcanvas';

export const MouseManager = {
  init: function(playcanvasApp) {
    this.playcanvasApp = playcanvasApp;
    this.fromWorldPoint = new pc.Vec3();
    this.toWorldPoint = new pc.Vec3();
    this.worldDiff = new pc.Vec3();

    this.cursor = document.getElementById('cursor_glow');
    if (pc.platform.touch) {
      this.cursor.style.opacity = 0;
    }

    this.cursor_x = 0;
    this.cursor_y = 0;
    this.cursor_ease = 3;

    // default outputvalues
    this.dx = this.dy = this.nx = this.ny = 0;

    // Mouse listeners
    this.playcanvasApp.mouse.on(pc.EVENT_MOUSEMOVE, this.onMouseMove, this);
    this.playcanvasApp.touch.on(pc.EVENT_TOUCHSTART, this.onTouchStart, this);
    this.playcanvasApp.touch.on(pc.EVENT_TOUCHMOVE, this.onTouchMove, this);
    this.playcanvasApp.touch.on(pc.EVENT_TOUCHEND, this.onTouchEnd, this);

    // No right-clickonMouse
    playcanvasApp.mouse.disableContextMenu();

    // Get correct window size when rezied
    window.addEventListener('resize', function() {
      MouseManager.onWindowResize();
    });

    this.onWindowResize();
  },
  update: function(dt) {
    if (this.dx === this.pdx) {
      this.dx = 0;
    }
    if (this.dy === this.pdy) {
      this.dy = 0;
    }

    this.pdx = this.dx;
    this.pdy = this.dy;

    // update Mouse cursor
    this.cursor_x += (this.nx - this.cursor_x) / this.cursor_ease;
    this.cursor_y += (this.ny - this.cursor_y) / this.cursor_ease;
    this.cursor.style.left = `${this.cursor_x * 100}%`;
    this.cursor.style.top = `${this.cursor_y * 100}%`;
  },
  onMouseMove: function(event) {
    const sw = this.screenWidth;
    const sh = this.screenHeight;
    // delta
    this.dx = event.dx / sw;
    this.dy = event.dy / sh;
    // normalised
    this.nx = event.x / sw;
    this.ny = event.y / sh;
  },
  onTouchStart(event) {
    this.touchX = event.touches[0].x;
    this.touchY = event.touches[0].x;
    this.prevTouchX = this.touchX;
    this.prevTouchY = this.touchY;
    this.dx = 0;
    this.dy = 0;
  },
  onTouchMove: function(event) {
    const sw = this.screenWidth;
    const sh = this.screenHeight;

    this.prevTouchX = this.touchX;
    this.prevTouchY = this.touchY;
    const t = event.touches[0];
    this.touchX = t.x;
    this.touchY = t.y;

    // delta
    this.dx = (this.touchX - this.prevTouchX) / sw;
    this.dy = (this.touchY - this.prevTouchY) / sh;
    // normalised
    this.nx = this.touchX / sw;
    this.ny = this.touchY / sh;
  },
  onTouchEnd: function(event) {
    this.dx = 0;
    this.dy = 0;
  },


  onWindowResize: function() {
    this.screenWidth = document.documentElement.clientWidth;
    this.screenHeight = document.documentElement.clientHeight;
  },
};
